import { PIEZO_SIGNING_FAILED_MESSAGE } from '../client/piezo/provisioning/PiezoClient.constants';

/**
 * Banner text for a failed request: `<prefix> Failed with <reason>`, or the Piezo guidance on its own when the
 * server refused the request because it could not be signed.
 */
export const errorBanner = (prefix: string, error: unknown): string => {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return message.includes(PIEZO_SIGNING_FAILED_MESSAGE) ? PIEZO_SIGNING_FAILED_MESSAGE : `${prefix} Failed with ${message}`;
};
